import React from 'react';
import './index.scss';

export default ({ onClick }) => {
  return (
    <label className="switch">
      <input type="checkbox" onClick={onClick} />
      <span className="slider round" />
    </label>
  );
};
